const SCHEDULED_STUDY_TYPE_OTHERS = {
  value: 0,
  label: 'その他の技術',
};

export { SCHEDULED_STUDY_TYPE_OTHERS };
